module.exports = __webpack_public_path__ + "img/phone.d249d4bd.svg";